import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Group, Badge } from "@mantine/core";
import PdfLabel from "./PdfLabel";
import { Trash } from "tabler-icons-react";
import { setup_user_stapeltodocs_delete_doc } from "../../slice/mainslice";
import { StapelUseCount } from "./StapelUseCount";
import intl from "react-intl-universal";

/* =====================
   TYPES
===================== */

type Props = {
  stapelId?: number;
  localStapelId?: string;
};

/* =====================
   COMPONENT
===================== */

const SelectedStapelSignDocsforUser = ({
  stapelId,
  localStapelId,
}: Props) => {
  const dispatch = useDispatch();

  const initdocstosign = useSelector(
    (state: any) => state.user.meetingdocs
  );

  const stapeluser = useSelector(
    (state: any) => state.user.userhavetostapelsigndocs
  ) ?? [];



 

  /* =====================
     AKTUELLER STAPEL
     🔑 stapelId > localStapelId
  ===================== */

  const stapel = stapeluser.find((s: any) => {
    if (stapelId && s.id) {
      return s.id === stapelId;
    }
    if (localStapelId && s.localStapelId) {
      return s.localStapelId === localStapelId;
    }
    return false;
  });

  if (!stapel) return null;

  const { documentsSignModes } = stapel;

  const allStapelsForUser = stapeluser.filter(
  (s: any) => s.participantId === stapel.participantId
  );



  /* =====================
     FILTER DOCS
  ===================== */

  const filteredDocs = initdocstosign.filter(
    (doc: { resourceId: string }) =>
      documentsSignModes.some(
        (item: { resourceId: string }) =>
          item.resourceId === doc.resourceId
      )
  );

  const isPDF = (fileName: string) => fileName.endsWith(".pdf");

  const { getUsageCount } = StapelUseCount(
          stapel.participantId,
          stapel.initialStapel?.stapelId,
          stapel.initialStapel?.localStapelId,
          { includeCurrentStapel: false }
        );



  /* =====================
     DELETE HANDLER
  ===================== */

  const deleteDoc = (resourceId: string) => {


    dispatch(
      setup_user_stapeltodocs_delete_doc({
        stapelId: stapel.id,              // 🔑 aus stapel
        localStapelId: stapel.localStapelId,
        resourceId,
      })
    );

     console.log("stapel", stapel);

    if (!stapel.id) return;

    const remaining = documentsSignModes.filter(
      (d: any) => d.resourceId !== resourceId
    );

    

    if (remaining.length === 0) {
      dispatch({
        type: "SIGNALR_REMOVESTAPEL",
        payload: { StapelId: stapel.id },
      });
    } else {
      dispatch({
        type: "SIGNALR_UPDATESTAPELFORSIGN",
        payload: {
          StapelId: stapel.id,
          documentsSignModes: remaining,
        },
      });
    }
  };

  /* =====================
     RENDER
  ===================== */

  //console.log("filteredDocs", filteredDocs);

  return (
    <Grid>
      {filteredDocs.map((doc: any) => (

        <React.Fragment key={doc.resourceId}>
          <Grid.Col span={11}>
            <Group spacing="xs">
              {isPDF(doc.name) && (
                <PdfLabel
                  isPDFA1b={doc.isPDFA1b}
                  signatureCount={doc.signatureCount}
                />
              )}
              {doc.name} 
            </Group>
            {getUsageCount(doc.resourceId) > 1 &&
              <Badge size="sm">{intl.get("SELECTEDSTAPELSIGNFOCS_INFO_IN")} {getUsageCount(doc.resourceId)} {intl.get("SELECTEDSTAPELSIGNFOCS_INFO")}</Badge>
               }
              
          </Grid.Col>
          <Grid.Col span={1}>
            <Trash
              color="red"
              onClick={() => deleteDoc(doc.resourceId)}
            />
          
          </Grid.Col>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default SelectedStapelSignDocsforUser;